export default __webpack_public_path__ + "151b5ac291f2727c79d38b682b497b08.png";